import { UserClientEntity } from 'entityTypes/UserClient';

export const getUserClientByActiveClientUuid = (
  userClients: UserClientEntity[],
  activeClientUuid: string
): UserClientEntity | undefined => {
  return userClients?.find((uc) => uc.client.clientUuid === activeClientUuid) ?? undefined;
};
